<div id="outer" class="well container">
    @if (loading) {
        <div class="loading"></div>
    }
    <div class="col-md-12">
        <div class="well-notify"></div>
    </div>
    <div class="well-title">
        <div class="col-md-12">Manage Document Types</div>
    </div>
    <div class="col-md-12 well-content">
        <div style="display: flex; gap: 8px; align-items: center">
            <nz-select [(ngModel)]="searchField" style="width: auto">
                @for (field of searchFields; track field) {
                    <nz-option [nzValue]="field.value" [nzLabel]="field.label"></nz-option>
                }
            </nz-select>
            <input
                nz-input
                [(ngModel)]="searchValue"
                placeholder="Enter search criteria..."
                style="width: 200px"
                (keydown.enter)="onSearch()" />
            <button nz-button nzType="primary" (click)="onSearch()">Search</button>
            <button nz-button (click)="clearSearch()">Reset</button>
        </div>
        <div style="margin-top: 10px; margin-bottom: 16px; display: flex; gap: 8px; align-items: center">
            <button nz-button class="btn-success" [routerLink]="['/configure/documenttypecreate']">
                New Document Type
            </button>
        </div>
        <nz-table
            #keywordTable
            [nzData]="documentTypes.Data"
            nzShowSizeChanger
            nzTableLayout="fixed"
            nzBordered="true"
            [nzFrontPagination]="false"
            [nzLoading]="loading"
            [nzTotal]="total"
            [nzShowTotal]="totalTemplate"
            [nzPageSize]="pageSize"
            [nzPageSizeOptions]="pageSizeOptions"
            [nzPageIndex]="pageIndex"
            (nzQueryParams)="onQueryParamsChange($event)">
            <thead style="border: 1px solid black">
                <tr>
                    @for (column of columns; track column) {
                        @if (column.enabled) {
                            <th
                                [nzShowSort]="column.compare"
                                [nzSortFn]="column.compare"
                                [nzColumnKey]="column.fieldName"
                                [nzSortOrder]="getSortOrder(column.fieldName)">
                                {{ column.title }}
                            </th>
                        }
                    }
                </tr>
            </thead>
            <tbody>
                @for (data of documentTypes.Data; track data.DocumentTypeID) {
                    <tr>
                        <td class="scrollable-cell">{{ data.DocumentTypeName }}</td>
                        <td style="text-align: center">{{ data.FileTypeName }}</td>
                        <td style="text-align: center">{{ data.Documents }}</td>
                        <td style="text-align: center">{{ data.Aliases }}</td>
                        <td style="text-align: center">{{ data.Keywords }}</td>
                        <td style="text-align: center">{{ data.KeywordAliases }}</td>
                        <td style="text-align: center">
                            <button
                                nz-button
                                [routerLink]="['/configure/documenttypeedit']"
                                [queryParams]="{id: data.DocumentTypeID}"
                                nz-tooltip="Edit {{ data.DocumentTypeName }}"
                                class="btn btn-default">
                                <span class="fa-solid fa-pen-to-square"></span>
                            </button>
                        </td>
                    </tr>
                }
            </tbody>
        </nz-table>
        <ng-template #totalTemplate let-total>
            Showing items {{ pageIndex * pageSize - pageSize + 1 }}–{{
                pageIndex * pageSize > total ? total : pageIndex * pageSize
            }}
            out of {{ total }}
        </ng-template>
    </div>
</div>
